<template>
  <div class="header" :class="[config.theme]">
    <client-only>
      <div v-show="inApp" class="safe-area-inset-top"></div>
      <div class="header-wrapper" :class="{ inApp: inApp }">
        <div class="header__left" v-show="hasCheckApp && !inApp">
          <NuxtLink class="logo-wrapper" :to="`/nft/home/${locale}`">
            <img
              v-if="config.theme === 'black' || config.theme === 'transparent-white'"
              class="logo"
              src="~/assets/img/logo.png"
              alt="bitmart"
            />
            <img v-else class="logo" src="~/assets/img/logo4.svg?url" alt="bitmart" />
            <img class="sub-logo" src="~/assets/img/logo-nft.svg?url" alt="bitmart nft" />
          </NuxtLink>
          <div class="nav">
            <NuxtLink
              :to="item.link"
              class="nav__item"
              :key="item.name"
              :class="item.active ? 'active' : ''"
              v-for="item in menuList"
              >{{ item.label }}</NuxtLink
            >
            <el-popover placement="bottom" trigger="hover" popper-class="nft-header__popper">
              <template #reference>
                <div class="nav__item">
                  {{ $t('nft_common.community') }}
                  <r-icon name="icon-zhankai" />
                </div>
              </template>
              <div class="community-list">
                <a href="https://twitter.com/BitMartExchange" target="_blank" rel="nofollow noopener noreferrer">{{
                  $t('nft_common.twitter')
                }}</a>
                <a href="https://t.me/BitmartExchange" target="_blank" rel="nofollow noopener noreferrer">{{
                  $t('nft_common.telegram')
                }}</a>
              </div>
            </el-popover>
            <NuxtLink :to="`/${locale}`" class="nav__item">Exchange</NuxtLink>
          </div>
        </div>
        <div class="header__left" v-show="hasCheckApp && !!inApp">
          <r-icon :size="18" name="icon-back" @click.native="pageBack" />
          <div style="height: 20px; width: 1px; background-color: #e7eaef; margin: 0 14px"></div>
          <IconMenu @click.native="toggleModal" :color="config.menuColor" />
        </div>
        <div class="header__right" v-show="hasCheckApp && !inApp">
          <div class="nav">
            <!-- <NuxtLink class="back-wrapper" :to="`/${locale}`">
          <img v-if="config.theme !== 'transparent-white'" src="~/assets/img/nft/header/icon-back.png" />
          <img v-else src="~/assets/img/nft/header/icon-back-opacity.png" />
          <span>{{$t("nft_common.return_to_master")}}</span>
        </NuxtLink> -->
            <template v-if="!isLogined">
              <a @click="goLogin()" class="nav__item">{{ $t('nft_common.sign_in') }}</a>
              <r-button @click="goRegister()" class="login-btn" type="primary">{{
                $t('nft_common.get_started')
              }}</r-button>
            </template>
            <el-popover v-else width="260" placement="bottom" trigger="hover" popper-class="nft-header__popper">
              <template #reference>
                <span class="nav__item">{{ userName }}</span>
              </template>
              <div class="header__user-list">
                <p class="username">{{ userName }}</p>
                <div class="menu">
                  <NuxtLink :to="`/nft/usercenter/${locale}?type=ASSETS`">
                    <div class="menu__item">
                      <img src="~/assets/img/nft/header/icon-nft-asset.png" />
                      <span>{{ $t('nft_common.nft_asset') }}</span>
                    </div>
                  </NuxtLink>
                  <NuxtLink :to="`/nft/usercenter/${locale}?type=ORDER_HISTORY`">
                    <div class="menu__item">
                      <img src="~/assets/img/nft/header/icon-order-history.png" />
                      <span>{{ $t('nft_common.order_history') }}</span>
                    </div>
                  </NuxtLink>
                </div>
                <div v-show="!inApp" class="logout-btn" @click="doLogout">
                  {{ $t('nft_common.logout') }}
                </div>
              </div>
            </el-popover>
            <div class="nav__item">
              <LanguagePicker align="right" />
            </div>
          </div>
          <div class="nav-menu--mobile" v-if="!disabledInQuery || !isAppIOS">
            <IconMenu @click.native="toggleModal" :color="config.menuColor" />
          </div>
        </div>
        <div class="header__right" v-show="hasCheckApp && !!inApp">
          <r-icon :size="18" name="icon-actions_navigation_close" @click.native="pageClose" />
        </div>
        <div class="header__modal" :class="hasModalOpen ? '' : 'dn'">
          <div v-show="inApp" class="safe-area-inset-top"></div>
          <!-- 弹出菜单栏顶部  -->
          <div class="modal__top">
            <div v-if="!mobileLocaleShow" class="top__logo" @click="mobileGo(`/nft/${locale}/home`)">
              <img class="logo" src="~/assets/img/logo4.svg?url" alt="bitmart" />
              <img class="sub-logo" src="~/assets/img/logo-nft.svg?url" alt="bitmart nft" />
            </div>
            <!-- 语言弹框时展示返回按钮 -->
            <i v-else class="bm-iconfont-new back-icon" @click="closeMobileLocale">&#xe64d;</i>
            <i class="bm-iconfont-new" @click="toggleModal">&#xe62a;</i>
          </div>
          <!-- 弹出菜单栏内容区块 -->
          <div v-show="!mobileLocaleShow" class="modal__content">
            <div class="user-info" v-if="isLogined">
              <p class="username">{{ userName }}</p>
              <div>
                <div class="user__nav" @click="mobileGo(`/nft/${locale}/usercenter?type=ASSETS`)">
                  <img src="~/assets/img/nft/header/icon-nft-asset.png" />
                  <span>{{ $t('nft_common.nft_asset') }}</span>
                </div>
                <div class="user__nav" @click="mobileGo(`/nft/${locale}/usercenter?type=ORDER_HISTORY`)">
                  <img src="~/assets/img/nft/header/icon-order-history.png" />
                  <span>{{ $t('nft_common.order_history') }}</span>
                </div>
              </div>
            </div>
            <div class="login-wrapper" v-else-if="!inApp">
              <a @click="goLogin()" class="nav__item">{{ $t('nft_common.sign_in') }}</a>
              <r-button @click="goRegister()" class="login-btn" type="primary">{{
                $t('nft_common.get_started')
              }}</r-button>
            </div>
            <div class="modal__nav">
              <div @click="mobileGo(item.link)" class="modal__nav__item" :key="item.name" v-for="item in menuList">
                {{ item.label }}
              </div>
              <div class="modal__nav__item" v-if="!isAppIOS">
                <p class="nav__item__title" @click="toggleMobileCommunity">
                  <span>{{ $t('nft_common.community') }}</span>
                  <i class="bm-iconfont-new" :class="hasMobileCommunityOpen ? 'up' : ''">&#xe610;</i>
                </p>
                <div class="nav__sub-wrapper" :class="hasMobileCommunityOpen ? 'active' : ''">
                  <a href="https://twitter.com/BitMartExchange" target="_blank" rel="nofollow noopener noreferrer">{{
                    $t('nft_common.twitter')
                  }}</a>
                  <a href="https://t.me/BitmartExchange" target="_blank" rel="nofollow noopener noreferrer">{{
                    $t('nft_common.telegram')
                  }}</a>
                </div>
              </div>
              <NuxtLink :to="`/${locale}`" class="modal__nav__item">Exchange</NuxtLink>
            </div>

            <div class="cur-locale" @click="openLanguageList">
              <div class="locale__wrapper">
                <!-- <span class="flag">{{ currLanguage.flag }}</span> -->
                <span>{{ currLanguage.name }}</span>
              </div>
              <i class="bm-iconfont-new icon-angle">&#xe610;</i>
            </div>
            <!-- 返回主站和登出的按钮 -->
            <div class="footer__wrapper">
              <!-- <NuxtLink :to="`/${locale}`" class="footer__btn">{{
            $t('nft_common.return_to_master')
          }}</NuxtLink> -->
              <div v-if="isLogined && !inApp" class="footer__btn" @click="doLogout">
                {{ $t('nft_common.logout') }}
              </div>
            </div>
          </div>
          <!-- 弹出框选择语言区块 -->
          <div v-show="mobileLocaleShow" class="modal__content">
            <div class="locale-list">
              <p class="locale__title">{{ $t('nft_common.choose_language') }}</p>
              <div
                class="locale__item"
                :class="currLanguage.locale === language.locale ? 'active' : ''"
                @click="setLocale(language.locale)"
                :key="language.locale"
                v-for="language in languageList"
              >
                <div class="item__left">
                  <!-- <span class="flag">{{ language.flag }}</span> -->
                  <span>{{ language.name }}</span>
                </div>
                <i class="bm-iconfont-new choose-icon">&#xe63a;</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </client-only>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
// import { mapState, mapMutations, mapGetters } from 'vuex'
import { mapState, usePatchStore } from '~/common/js/patch';
import { breakDownHostUrl, isLoginedToken, switchLanguage, setUserInfoInApp } from '~/common/js/utils';
import { setAppLoginInfo } from '~/common/js/storeUtil';
import IconMenu from '~/components/icon/IconMenu';
import LanguagePicker from '~/components/global/LanguagePicker';
// import { countryNameMap } from '~/common/js/country-name'
import { axiosClient } from '~/common/js/axios';
import commonMixin from '@/mixins/common';
import { OLD_LOCALES_OBJ_REVERSE, OLD_LOCALES_OBJ } from '~/common/js/const';
import useLogin from '@/composables/useLogin';

const privateUserName = function (userName) {
  if (userName && userName.includes('@')) {
    const fName = userName.split('@')[0];
    return userName.replace(fName.length > 4 ? fName.slice(4) : fName, '***');
  }
  return userName;
};

export default {
  components: {
    LanguagePicker,
    IconMenu,
  },
  mixins: [commonMixin],
  props: {
    config: Object,
  },
  data() {
    return {
      sint: null,
      redirectUrl: '',
      hasMobileCommunityOpen: true, // 移动端community菜单默认打开
      // languageList: LANGUAGE_CONFIG,
      hasModalOpen: false, // 移动端菜单栏是否打开
      isRenewIng: false,
      mobileLocaleShow: false, // 移动端选择语言modal打开
      inApp: false, // 用来隐藏退登和注册按钮，app内使用
      hasCheckApp: false,
      isAppIOS: true,
    };
  },
  computed: {
    disabledInQuery() {
      return this.$route?.query?.disabledInQuery;
    },
    ...mapState({
      locale: (state) => state.locale,
      userName: (state) => privateUserName(state.userName || state.account.loginName),
      languageList: (state) =>
        state.localeConfigList.map((item) => ({
          ...item,
          // flag: countryNameMap[item.locale.split('-')?.[1]]?.flag || '',
        })),
      currLanguage: (state) => {
        const upcaseLocale = OLD_LOCALES_OBJ_REVERSE[state.locale] || state.locale;
        return {
          ...state.localeConfigList.find((item) => item.locale === upcaseLocale),
          // flag: countryNameMap[upcaseLocale.split('-')?.[1]]?.flag || '',
        };
      },
    }),
    menuList() {
      const list = [
        {
          label: this.$t('nft_common.home'),
          link: `/nft/${this.locale}/home`,
        },
      ];
      if (!this.isAppIOS) {
        list.push({
          label: this.$t('nft_common.marketplace'),
          link: `/nft/${this.locale}/marketplace`,
        });
      }
      list.push({
        label: this.$t('nft_common.ino'),
        link: `/launchpad/${this.locale}?activityType=ino`,
      });
      return list.map((nav) => ({
        ...nav,
        active: this.$route.name === nav.name,
      }));
    },
    isLogined() {
      return this.store.isLogined;
    },
  },
  created() {
    const commit = this.store.commit;
    if (process.client && Cookies.get('userName')) {
      commit('SET_USER', Cookies.get('userName'));
    }
    this.$$isApp().then((isApp) => {
      this.inApp = isApp;
      this.hasCheckApp = true;
    });
  },
  mounted() {
    const { store } = usePatchStore();
    const n = reactive({
      name: 123,
    });
    console.log('store >>>>>> mounted', store, n);
    this.$$isApp().then((isApp) => {
      setUserInfoInApp(isApp, this.store);
      import('amfe-env').then((env) => {
        this.isAppIOS = isApp && env.os.isIOS;
      });
    });
    // this.appReady()
    // 设置登录回调地址
    this.redirectUrl = window.location.href;

    // clearTimeout(this.sint)
    // // 避免别的 window 已经登录
    // this.sint = setInterval(() => {
    //   const userName = Cookies.get('userName')
    //   if (userName && userName !== 'undefined') {
    //     this.store.commit('SET_USER', Cookies.get('userName'))
    //     clearTimeout(this.sint)
    //   }

    //   // if (isLoginedToken()) {
    //   //   this.reToken()
    //   // }
    // }, 2000)

    // this.$$isApp().then((isApp) => {
    //   this.inApp = isApp
    //   if (isApp) {
    //     setTimeout(() => {
    //       this.store.dispatch('account/getUserSecInfo')
    //     }, 10000)
    //   } else {
    //     this.store.dispatch('account/getUserSecInfo')
    //   }
    // })
  },
  methods: {
    // ...mapMutations({
    //   setToken: 'SET_TOKEN',
    //   setSalt: 'SET_SALT',
    //   setUser: 'SET_USER',
    // }),
    setToken(data) {
      // this.store.commit('SET_TOKEN', data);
    },
    setSalt(data) {
      this.store.commit('SET_SALT', data);
    },
    setUser(data) {
      this.store.commit('SET_USER', data);
    },
    goLogin() {
      if (this.isLoginedToken()) {
        return;
      }
      this.$$isApp().then((isApp) => {
        if (isApp && window.jsBridge?.invoke) {
          window.jsBridge.invoke('toLogin', {}, function (res) {
            res = res.replace(/(Optional\("(.*)"\)\))/, '$2');
            const paramsObj = JSON.parse(res);
            if (paramsObj?.success) {
              setAppLoginInfo(this.store, paramsObj);
            }
          });
        } else {
          this.hasLogin();
        }
      });
    },
    goRegister() {
      if (this.isLoginedToken()) {
        return;
      }
      const { name, query } = this.$route;

      // 注册没验证过，不搞了，app内直接隐藏注册按钮
      // this.$$isApp().then((isApp) => {
      //   if (isApp && window.jsBridge?.invoke) {
      //     window.jsBridge.invoke('register', {}, function (res) {
      //       window.location.reload()
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'register-lang',
      //       query: {
      //         goto: name,
      //         others: JSON.stringify(query),
      //       },
      //     })
      //   }
      // })
      this.$router.push({
        name: 'register-lang',
        query: {
          goto: name,
          others: JSON.stringify(query),
        },
      });
    },
    async reToken() {
      if (this.isRenewIng) {
        return;
      }
      let tokenAt = window.localStorage.getItem('tokenAt');
      if (!tokenAt) {
        tokenAt = Date.now();
        window.localStorage.setItem('tokenAt', Date.now());
      }

      if (Date.now() - tokenAt < 0.5 * 24 * 60 * 60 * 1000) {
        return;
      }
      const webDomain = breakDownHostUrl(location.hostname);
      const cookieOptions = {
        expires: 30,
        httpOnly: false,
      };
      if (!webDomain.includes('localhost')) {
        Object.assign(cookieOptions, {
          domain: `.${webDomain}`,
        });
      }
      this.isRenewIng = true;
      const ret = await axiosClient({
        method: 'POST',
        url: '/gw-api/gateway/token/renew',
        Headers: {
          Authorization: Cookies.get('accessToken'),
        },
      });
      this.isRenewIng = false;
      if (ret?.success) {
        const userName = Cookies.get('userName');
        if (userName && userName !== 'undefined') {
          Cookies.set('userName', userName, cookieOptions);
        }
        Cookies.set('accessToken', ret.data.accessToken, cookieOptions);
        Cookies.set('accessSalt', ret.data.accessSalt, cookieOptions);
        window.localStorage.setItem('tokenAt', Date.now());
      }
    },
    async doLogout() {
      // TODO 3619
      const token = Cookies.get('accessToken');
      await axiosClient({
        method: 'POST',
        url: '/gw-api/user-center/token/logout',
        data: {
          token,
        },
        headers: {
          Authorization: token,
        },
      });

      this.setUser(null);
      this.setToken(null);
      this.setSalt(null);
      window.sessionStorage.clear();

      // this.$router.push(`/login/${this.locale}`)
      this.store.commit('SET_CLEAN_INFO');
      window.location.href = `/login/${this.locale}`;
    },
    // 展开mobile菜单
    toggleModal() {
      this.hasModalOpen = !this.hasModalOpen;
      this.mobileLocaleShow = false;
    },
    // 切换移动端community打开与关闭
    toggleMobileCommunity() {
      this.hasMobileCommunityOpen = !this.hasMobileCommunityOpen;
    },
    setLocale(lang) {
      this.hasModalOpen = false;
      this.mobileLocaleShow = false;
      const finalLang = OLD_LOCALES_OBJ[lang] || lang;
      switchLanguage(finalLang, this.$route, this.$router);
    },
    // 打开移动端选择语言
    openLanguageList() {
      this.mobileLocaleShow = true;
    },
    // 关闭移动端选择语言
    closeMobileLocale() {
      this.mobileLocaleShow = false;
    },
    // mobile菜单栏点击link跳转
    mobileGo(url) {
      this.$router.push(url);
      this.hasModalOpen = false;
    },
    pageBack() {
      if (this.inApp && window.jsBridge?.invoke) {
        window.jsBridge.invoke('navigatePopPageStack', {});
      } else {
        history.back();
      }
    },
    pageClose() {
      if (this.inApp && window.jsBridge?.invoke) {
        window.jsBridge.invoke('navigateBack', {});
      }
    },
  },
  setup() {
    const { store } = usePatchStore();
    const { hasLogin, gotoLogin, isLoginedToken } = useLogin();
    return {
      store,
      hasLogin,
      gotoLogin,
      isLoginedToken,
    };
  },
};
</script>
<style lang="less">
.safe-area-inset-top {
  height: calc(env(safe-area-inset-top)) !important;
}
.nft-header__popper {
  padding: 0 !important;
  box-shadow: 0px 3px 12px rgba(20, 31, 33, 0.1);
  border-radius: 4px !important;
  border: 0;
  top: 80px !important;
  margin-top: 0 !important;
  position: fixed !important;
  .popper__arrow {
    display: none;
  }
}
</style>
<style lang="less" scoped>
.header {
  // box-sizing: border-box;
  width: 100%;
  // height: 80px;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  // padding: 0 40px;
  transition: background 0.3s ease;
  .header-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
  }
  .header__left {
    display: flex;
    align-items: center;
    .logo-wrapper {
      display: flex;
      align-items: center;
    }
    .logo {
      width: 106px;
      margin-right: 8px;
    }
    .sub-logo {
      width: 37.5px;
      font-size: 20px;
      font-weight: 600;
    }
  }
  .nav {
    margin-left: 40px;
    font-size: 14px;
    display: flex;
    align-items: center;
    .nav__item {
      margin-right: 24px;
      display: flex;
      align-items: center;
      cursor: pointer;
      :deep(.r-icon) {
        margin-left: 2px;
      }
      &:hover {
        color: #13c2c2;
        transition: all 0.3s ease;
        :deep(.r-icon) {
          transform: rotate(180deg);
        }
      }
      &.active {
        font-weight: 600;
      }
      .item__icon {
        color: #91a5b1;
        margin-left: 5.83px;
      }
    }
    .login-btn {
      padding: 11px 16px;
      margin-right: 24px;
      font-weight: 600;
      font-size: 14px;
      height: 40px;
    }
    .back-wrapper {
      margin-right: 24px;
      color: #6a7c81;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s ease;
      &:hover {
        color: #13c2c2;
      }
      img {
        margin-right: 4px;
        width: 20px;
      }
    }
  }
  &.transparent-black {
    background: transparent;
    color: #141f21;
  }
  &.transparent-white {
    background: transparent;
    color: #fff;
    .back-wrapper {
      color: #fff;
      opacity: 0.6;
      img {
        opacity: 1;
      }
    }
  }
  &.black {
    background: #222;
    color: #fff;
    .back-wrapper {
      color: #fff;
    }
  }
  &.white {
    background: #fff;
    color: #141f21;
  }
}
.community-list {
  border-radius: 4px;
  overflow: hidden;
  a {
    display: block;
    height: 56px;
    line-height: 56px;
    padding: 0 16px;
    font-size: 16px;
    color: #141f21;
    &:hover {
      background: #f5f9fb;
    }
  }
}
.header__user-list {
  width: 260px;
  padding-bottom: 30px;
  color: #141f21;
  .username {
    height: 74px;
    line-height: 74px;
    padding: 0 16px;
    font-size: 20px;
    font-weight: 600;
  }
  .menu {
    .menu__item {
      padding: 0 16px;
      display: flex;
      align-items: center;
      height: 56px;
      line-height: 56px;
      font-size: 16px;
      &:hover {
        background: #f5f9fb;
      }
      img {
        width: 20px;
        margin-right: 20px;
      }
    }
  }
  .logout-btn {
    box-sizing: border-box;
    width: calc(100% - 32px);
    margin: 0 16px;
    height: 35px;
    line-height: 33px;
    border: 1px solid #92a4a9;
    border-radius: 4px;
    margin-top: 20px;
    font-weight: 600;
    text-align: center;
    color: #3e4648;
    cursor: pointer;
    &:hover {
      border: 1px solid #13c2c2;
      color: #13c2c2;
    }
  }
}
.header.black {
  .back-wrapper {
    color: #fff;
  }
}

@media screen and (min-width: 1022px) {
  .header {
    .nav-menu--mobile {
      display: none;
    }
    .header__modal {
      display: none;
    }
  }
}

@media screen and (max-width: 1021px) {
  .header {
    .header-wrapper {
      height: 48px;
      padding: 0 20px;
      &.inApp {
        height: 56px;
        // padding-top: calc(env(safe-area-inset-top)) !important;
        .modal__top {
          height: 56px;
          // padding-top: calc(env(safe-area-inset-top)) !important;
        }
      }

      .nav {
        display: none;
      }
      .logo {
        width: 100px;
      }
      .nav-menu--mobile {
        display: block;
        margin-top: -10px;
      }
    }
    .header__modal {
      width: 100%;
      height: 100%;
      background: #fff;
      color: #141f21;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 3;
      padding: 0 24px;
      box-sizing: border-box;
      transform: translate(0, 0);
      transition: transform 0.3s ease;
      overflow-x: scroll;
      &.dn {
        transform: translate(100%, 0);
      }
      .modal__top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 48px;
        margin-bottom: 40px;
        .top__logo {
          display: flex;
          align-items: center;
          .sub-logo {
            width: 37.5px;
            font-size: 20px;
            font-weight: 600;
            margin-left: 8px;
          }
        }
        .bm-iconfont-new {
          font-size: 20px;
        }
      }
      .user-info {
        .username {
          font-size: 24px;
          color: #141f21;
          font-weight: 600;
          margin-bottom: 35px;
        }
        .user__nav {
          display: flex;
          align-items: center;
          margin-bottom: 35px;
          img {
            margin-right: 15px;
            width: 22px;
          }
        }
      }
      .login-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .login-btn-wrapper {
          display: block;
          width: 100%;
        }
        .login-btn {
          width: 100%;
          background: #13c2c2;
          font-size: 14px;
          display: block;
          font-weight: 600;
          color: #fff;
          height: 44px;
          border: 0;
          margin: 25px 0 36px;
        }
      }
      .modal__nav {
        padding-top: 35px;
        border-top: 1px solid #f5f9fb;
        .modal__nav__item {
          margin-bottom: 24px;
          display: block;
        }
        .nav__item__title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .bm-iconfont-new {
            font-weight: bold;
            transition: all 0.3s ease;
            &.up {
              transform: rotate(180deg);
            }
          }
        }
        .nav__sub-wrapper {
          font-size: 14px;
          color: #6a7c81;
          max-height: 0;
          transition: max-height 0.3s ease;
          visibility: hidden;
          padding-top: 1px;
          &.active {
            max-height: 200px;
            visibility: visible;
          }
          a {
            display: block;
            margin-top: 16px;
          }
        }
      }
      .modal__content {
        // height: calc(100% - 88px);
        padding-bottom: 178px;
        position: relative;
        .locale__title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 25px;
        }
        .locale__item {
          margin-bottom: 25px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .item__left {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #141f21;
            flag {
              margin-right: 8px;
            }
          }
          .choose-icon {
            display: none;
          }
          &.active {
            font-weight: 600;
            .choose-icon {
              color: #13c2c2;
              display: block;
            }
          }
        }
        .footer__wrapper {
          position: absolute;
          width: 100%;
          padding-bottom: 36px;
          bottom: 0;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          .footer__btn {
            width: 100%;
            height: 44px;
            line-height: 44px;
            border: 1px solid #92a4a9;
            border-radius: 4px;
            text-align: center;
            font-size: 14px;
            font-weight: 600;
            margin-top: 10px;
          }
        }
        .cur-locale {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 16px;
          color: #141f21;
          .locale__wrapper {
            display: flex;
            align-items: center;
          }
          .flag {
            margin-right: 8px;
          }
          .icon-angle {
            font-weight: bold;
            transform: rotate(-90deg);
          }
        }
      }
    }
  }
}
</style>
